var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1C3.4673 1 1 3.4673 1 6.5V8.77865C1 9.34185 1.49335 9.8 2.1 9.8H2.65C2.79587 9.8 2.93576 9.74205 3.03891 9.63891C3.14205 9.53576 3.2 9.39587 3.2 9.25V6.42135C3.2 6.27548 3.14205 6.13559 3.03891 6.03244C2.93576 5.9293 2.79587 5.87135 2.65 5.87135H2.1506C2.4564 3.74285 4.2879 2.1 6.5 2.1C8.7121 2.1 10.5436 3.74285 10.8494 5.87135H10.35C10.2041 5.87135 10.0642 5.9293 9.96109 6.03244C9.85795 6.13559 9.8 6.27548 9.8 6.42135V9.8C9.8 10.4067 9.30665 10.9 8.7 10.9H7.6V10.35H5.4V12H8.7C9.9133 12 10.9 11.0133 10.9 9.8C11.5067 9.8 12 9.34185 12 8.77865V6.5C12 3.4673 9.5327 1 6.5 1Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRsp);
export default __webpack_public_path__ + "static/media/IconRsp.d6222bf2297d7807a9610fddad189465.svg";
export { ForwardRef as ReactComponent };